import { CasTabButtonsView } from 'src/compass/shared/components';

import InfoTab from './InfoTab';
import PropertyTab from './propertyTab/PropertyTab';

export default function ClaimTrackingPropertyTab() {
  return (
    <CasTabButtonsView
      buttonList={[
        { label: 'Properties', children: <PropertyTab /> },
        { label: 'Info', children: <InfoTab /> },
      ]}
    />
  );
}
